module.exports = __webpack_public_path__ + "static/media/chart-column-fill.c18b984e.svg";